import { apiFetch } from './client';

export const authApi = {
  login: (email, password, remember_me = false) =>
    apiFetch('/api/auth/login', {
      method: 'POST',
      body: { email, password, remember_me },
    }),
  logout: () => apiFetch('/api/auth/logout', { method: 'POST' }),
  me: () => apiFetch('/api/auth/me'),
  changePassword: (current_password, new_password) =>
    apiFetch('/api/auth/change-password', {
      method: 'POST',
      body: { current_password, new_password },
    }),
  exportPermissions: () => apiFetch('/api/auth/export-permissions'),
  enableMfa: () => apiFetch('/api/auth/mfa/enable', { method: 'POST' }),
};
